import { render, staticRenderFns } from "./cp_gotop.vue?vue&type=template&id=1e2fe7e8&scoped=true"
import script from "./cp_gotop.vue?vue&type=script&lang=js"
export * from "./cp_gotop.vue?vue&type=script&lang=js"
import style0 from "./cp_gotop.vue?vue&type=style&index=0&id=1e2fe7e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2fe7e8",
  null
  
)

export default component.exports